export default __webpack_public_path__ + "static/media/rei.022ea033.png";